import { useContext, useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogTitle, Button, FormControlLabel, FormLabel, RadioGroup, Radio } from '@mui/material'

import exportFromJSON from 'export-from-json'

import SaveAltIcon from '@mui/icons-material/SaveAlt'
import DataObjectIcon from '@mui/icons-material/DataObject'
import BorderAllIcon from '@mui/icons-material/BorderAll'

import { AppContext } from '/providers/app-context'

const ArchiveDialog = ({ open, setOpen, fileName, data, excelExport, csvExport, template }) => {

  const { processing, user } = useContext(AppContext)

  const [exportFormat, setExportFormat] = useState(user?.preferences.data_format)

  useEffect(() => {
    setExportFormat(user?.preferences.data_format)
  }, [user])

  const close = () => setOpen(false)

  const exportData = () => {
    switch (exportFormat) {
      case "json": return exportJSON()
      case "csv": return exportCSV()
      case "xls": return exportXLS()
    }
  }

  const exportJSON = () => {
    const exportType = exportFromJSON.types.json

    if (Array.isArray(data)) {
      exportFromJSON({ data, fileName, exportType })
    } else {
      for (let key in data) {
        const dataItem = data[key]
        if (dataItem.length) {
          const fn = fileName + "-" + key
          exportFromJSON({ data: dataItem, fileName: fn, exportType })
        }
      }
    }
    close()
  }

  const exportCSV = () => {

    const exportType = exportFromJSON.types.csv

    if (csvExport) {
      const csvData = csvExport(data)
      exportFromJSON({ data: csvData, fileName, exportType })
    } else {

      if (Array.isArray(data)) {
        exportFromJSON({ data, fileName, exportType })
      } else {
        for (let key in data) {
          const dataItem = data[key]
          if (dataItem.length) {
            const fn = fileName + "-" + key
            exportFromJSON({ data: dataItem, fileName: fn, exportType })
          }
        }
      }
    }
    
    close()
  }

  const exportXLS = () => {
    excelExport({ fileName, data, template })
    close()
  }

  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Data export
      </DialogTitle>

      <div className='p-5'>

        <div className='mb-5'>NOTE: Data export will only export the data that you have loaded in your table. If your data has not finished loading, or you have not loaded both LIVE and TEST data then cancel this export, continue to load all the data you need then export again.</div>

        <FormLabel id="export-format-label" className='mt-5'>Export format</FormLabel>
        <RadioGroup
          aria-labelledby="export-format-label"
          row
          value={exportFormat}
          onChange={e => setExportFormat(e.target.value)}
        >
          <FormControlLabel value="json" control={<Radio />} label={<><DataObjectIcon /> JSON</>} />
          <FormControlLabel value="csv" control={<Radio />} label={<><span className='font-semibold'>[*,*]</span> CSV</>} />
          <FormControlLabel value="xls" control={<Radio />} label={<><BorderAllIcon /> Excel (XLSX)</>} />
        </RadioGroup>

      </div>

      <DialogActions>
        <div className="flex flex-row justify-between w-full p-5">
          <Button variant="outlined" onClick={close} disabled={processing}>Cancel</Button>
          <Button variant="contained" onClick={exportData} autoFocus disabled={processing}><SaveAltIcon className="mr-5" />Export Data</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default ArchiveDialog